/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SubmissionDetail } from './SubmissionDetail';
import {
    SubmissionDetailFromJSON,
    SubmissionDetailFromJSONTyped,
    SubmissionDetailToJSON,
    SubmissionDetailToJSONTyped,
} from './SubmissionDetail';

/**
 * 
 * @export
 * @interface SubmissionGetResponse
 */
export interface SubmissionGetResponse {
    /**
     * 
     */
    submissions: Array<SubmissionDetail>;
    /**
     * 
     */
    notFound: Array<string>;
}

/**
 * Check if a given object implements the SubmissionGetResponse interface.
 */
export function instanceOfSubmissionGetResponse(value: object): value is SubmissionGetResponse {
    if (!('submissions' in value) || value['submissions'] === undefined) return false;
    if ((!('notFound' in (value as Record<string, any>)) && !('not_found' in (value as Record<string, any>))) || ((value as Record<string, any>)['notFound'] === undefined && (value as Record<string, any>)['not_found'] === undefined)) return false;
    return true;
}

export function SubmissionGetResponseFromJSON(json: any): SubmissionGetResponse {
    return SubmissionGetResponseFromJSONTyped(json, false);
}

export function SubmissionGetResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubmissionGetResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'submissions': ((json['submissions'] as Array<any>).map(SubmissionDetailFromJSON)),
        'notFound': json['not_found'],
    };
}

export function SubmissionGetResponseToJSON(json: any): SubmissionGetResponse {
    return SubmissionGetResponseToJSONTyped(json, false);
}

export function SubmissionGetResponseToJSONTyped(value?: SubmissionGetResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'submissions': ((value['submissions'] as Array<any>).map(SubmissionDetailToJSON)),
        'not_found': value['notFound'],
    };
}

